"use client";

import { Check, Copy } from "lucide-react";
import { useTranslations } from "next-intl";
import { useState } from "react";

/** 模板页场景卡的「Copy prompt」，样子照 /image-to-image 的；文案用 assets.buttons，各语言都有 */
export function CopyPromptButton({ prompt }: { prompt: string }) {
	const t = useTranslations("assets.buttons");
	const [copied, setCopied] = useState(false);

	return (
		<button
			type="button"
			onClick={async () => {
				await navigator.clipboard.writeText(prompt);
				setCopied(true);
				setTimeout(() => setCopied(false), 2000);
			}}
			className="inline-flex items-center gap-1.5 self-start text-xs font-medium text-primary hover:underline"
		>
			{copied ? (
				<Check className="h-3.5 w-3.5" />
			) : (
				<Copy className="h-3.5 w-3.5" />
			)}
			{copied ? t("copied") : t("copyPrompt")}
		</button>
	);
}
